import administration from 'translations/fr/administration'
import auth from 'translations/fr/auth'
import employee from 'translations/fr/employee'
import forms from 'translations/fr/forms'
import components from 'translations/fr/components'
import manager from 'translations/fr/manager'
import onboarding from 'translations/fr/onboarding'
import punch from 'translations/fr/punch'
import searchBar from 'translations/fr/searchBar'
import chat from 'translations/fr/chat'
import titles from 'translations/fr/titles'
import upload from 'translations/fr/upload'

export default {
  ATTACHMENTS: {
    WARNING: "Les fichiers ne peuvent être joints qu'à des quarts de travail existants"
  },
  // Do not delete this, used for tests
  TRANSLATION_TEST: `Test translation`,
  TRANSLATION_TEST_CARD: {
    TITLE: `Test card title`,
    SUMMARY: `Test card summary`
  },
  USERNAME_PASSWORD_INVALID: `Mot de passe ou nom d'utilisateur invalide`,
  USER_ARCHIVED: `Votre compte a été archivé`,
  ATTEMPT_LIMIT_REACH: `Limite de tentatives atteinte`,
  EMAIL_DESCRIPTION: '',
  EMAIL_PLACEHOLDER: 'Entrez votre courriel',
  MUST_BE_A_VALID_EMAIL: `Adresse courriel invalide`,
  VALIDATION_ERROR: `Erreur de validation`,
  DATE_RANGE_MISSING: `Veuillez sélectionner une date de début et une date de fin`,
  RELEASES: `Mises à jour`,
  TRUE: `Vrai`,
  FALSE: `Faux`,
  actions: {
    SAVE: 'Enregistrer',
    EDIT: 'Modifier',
    CONFIRM: 'Confirmer',
    CANCEL: 'Annuler',
    DELETE: 'Supprimer',
    ARCHIVE: 'Archiver',
    ACCEPT: `Accepter`,
    VIEW: `Afficher`,
    BACK: `Retour`,
    DUPLICATE: `Dupliquer`,
    SUBMIT: `Soumettre`,
    ADD: `Ajouter`,
    CLOSE: `Fermer`,
    REMOVE: `Retirer`,
    SEND: `Envoyer`,
    APPLY: `Appliquer`,
    COPY: `Copier`,
    APPROVE: `Approuver`,
    UNAPPROVE: `Désapprouver`
  },
  push: {
    HOW_TO_ENABLE: `Comment les activer?`,
    PUSH_ARE_NOT_ALLOWED: `Les notifications ne sont pas autorisé`,
    WHY_PUSH: `Activer les notifications afin d'être informé lorsqu'une requête change de status, votre employeur vous envoie un message important ou que vous avez des offres de quart de travail.`
  },
  SELECTION_OPTIONS: {
    SELECTED_COUNT: `{{ count }} sélectionné`,
    SELECTED_COUNT_other: `{{ count }} sélectionnés`,
    SELECT_ALL: `Tout sélectionner`,
    CLEAR_SELECTION: `Tout désélectionner`
  },
  ALL_DAY: `Toute la journée`,
  NO_APP_ACCESS: `Vous n'avez accès à aucun des modules de l'application.`,
  NEW_VERSION_TITLE: `Nouvelle version disponible`,
  NEW_VERSION_DESCRIPTION: `Une nouvelle version de l'application est disponible. Veuillez cliquer ici afin d'actualiser l'application et implémenter les changements.`,
  REFRESH: `Actualiser`,
  'HOME-CALL': `Appel téléphonique`,
  'MOBILE-CALL': `Appel puis message texte`,
  'MOBILE-SMS': `Message texte`,
  'DO-NOT-USE': `Ne pas utiliser`,
  WORK: `Travail`,
  PERSONEL: `Personnel`,
  SUBMIT: `Soumettre`,
  NEXT: `Suivant`,
  PREVIOUS: `Precedent`,
  CANCEL: `Annuler`,
  COLOR: 'Couleur',
  HELP_CENTER: `Centre d'aide`,
  HELP_VIDEOS: `Tutoriels vidéo`,
  WHATS_NEW: `Nouveautés`,
  IMPORTANT_INFORMATION: `Informations importantes`,
  CONTACT_SUPPORT: `Contacter le support`,
  STARTS_ON: `Débute le`,
  ENDS_ON: `Termine le`,
  APPLICATION_ERROR: `Erreur interne`,
  APPLICATION_ERROR_DESC: `Une erreur est survenue, veuillez réessayer. Si l'erreur persiste, contactez votre gestionnaire.`,
  SOMETHING_WENT_WRONG: `Oups, une erreur est survenue.`,
  NO_DATA: `Aucune valeur`,
  TO: `à`,
  DATE_RANGE: `au`,
  INVALID_TOKEN: `Le lien que vous avez utiliser est invalide ou expiré.`,
  manageEmployee: { PASSWORD_REQUIREMENT: `Le mot de passe ne répond pas aux critères de sécurité établi. Veuillez essayer à nouveau.` },
  LOADING: `Chargement`,
  LEAVE: `Quitter`,
  NO_INTERNET_ACCESS: `Vous n'avez pas accès à Internet.`,
  WILL_RESUME_WHEN_INTERNET_AVAILABLE: `L'accès à l'application va être rétabli lorsque vous aurez accès.`,
  THIS_RESOURCE_DOESNT_EXIST_OR_HAS_BEEN_DELETED: `Cette ressource n'existe pas ou a été supprimée.`,
  INVALID_EMAIL: `Adresse courriel invalid`,
  NAME: `Nom`,
  DATE: `Date`,
  NAME_FR: `Nom français`,
  NAME_EN: `Nom anglais`,
  EXPORT_CODE: `Code d'exportation`,
  EXPORT_PDF: `Exporter PDF`,
  IMPORT_CODE: `Code d'importation`,
  EARNING_CODE: `Code de gain`,
  ARCHIVE: `Archiver`,
  UNARCHIVE: `Désarchiver`,
  DELETE: `Supprimer`,
  EDIT: `Modifier`,
  errors: {
    BAD_PASSWORD: {
      TITLE: `Mauvais mot de passe.`,
      DESCRIPTION: `Le mot de passe entré est invalid. Veuillez essayer à nouveau.`
    },
    BAD_USERNAME_CONFIRMATION: {
      TITLE: `Mauvais nom d'utilisateur`,
      DESCRIPTION: `Le nom d'utilisateur que vous avez entrez ne correspond pas au votre.`
    }
  },
  OPTIONS: `Options`,
  VIEW: `Vue`,
  EXPORT: `Export`,
  NO_SORT: `Aucun classement`,
  NO_FILTER: `Aucun filtre`,
  NO_CONFIG: `Aucune configuration`,
  NO_PROCEDURE: `Aucune procédure`,
  DESCRIPTION: `Description`,
  CLOSE: `Fermer`,
  SELECT: `Choisir`,
  SELECTED: `Selectionné`,
  SAVE: `Sauvegarder`,
  APPLY: `Appliquer`,
  NA: `N/D`,
  ROW_DATA_ERROR: `Quelque chose nous empêche d'afficher les informations contenues dans cette ligne.`,
  ROW_DATA_ERROR_ID: `L'identifiant unique est : {{_id}}`,
  PUSH_ERROR: `Une erreur est survenu durant l'inscription les push notifications.`,
  // TRANSLATIONS FOR THE APP SETTINGS ARRAY VALUE
  APPROVAL_REQUIRED: `Approbation requise`,
  CHANGES_REQUESTED: `Changement demandé`,
  ACKNOWLEDGE: `Reçue`,
  JUSTIFIED: `Justifiée`,
  UNJUSTIFIED: `Non justifiée`,
  IN_PROGRESS: `En cours`,
  APPROVED: `Approuvé`,
  ACKNOWLEDGED: `Reçue`,
  APPROVE: `Approuver`,
  REFUSED: `Refusé`,
  CANCELLED: `Annulé`,
  firstName: `Prénom`,
  lastName: `Nom de famille`,
  employeeNumber: `Numéro d'employé`,
  SUNDAY: `Dimanche`,
  MONDAY: `Lundi`,
  TUESDAY: `Mardi`,
  WEDNESDAY: `Mercredi`,
  THURSDAY: `Jeudi`,
  FRIDAY: `Vendredi`,
  SATURDAY: `Samedi`,
  FINALIZED: `Finalisé`,
  COMMENT: `Commentaire`,
  '1MONTH': `1 mois`,
  '2MONTH': `2 mois`,
  EN: `Anglais`,
  FR: `Français`,
  NETHRIS_EMPLOYEURD: `Nethris/EmployeurD`,
  APOGEE: `Apogée`,
  GENERIC: `Générique`,
  CLEAR: `Retirer`,
  SUBMIT_AND_CREATE_OTHER: `Soumettre et créer un autre`,
  SEARCH: `Chercher`,
  EMPLOYEE: `Employé`,
  SETTINGS: `Paramètres`,
  administration,
  auth,
  employee,
  forms,
  components,
  manager,
  onboarding,
  punch,
  searchBar,
  chat,
  titles,
  upload
}
